import { AxiosResponse } from "axios";
import { axiosInstance } from "src/services/axiosSetup";
import * as API_URL from "src/services/consts/History"

export function getEnquiryHistoryApiRequest(id: string): Promise<AxiosResponse<any>> {
    return axiosInstance.get(`${API_URL.URL_GET_ENQUIRY_HISTORY}/${id}`).then((d: AxiosResponse) => d.data)
}